export class BeneficioAtivoDependenteView {

    matricula: string;
    numeroDependente: number;
    possuiEducacao: boolean;
    possuiTransporte: boolean;

  }
  